<template>
  <div class="week-numbers">
    <div class="week-number" v-for="week in weekNumbers" :key="week.week">
      <div class="week-number__wrapper" :style="week.style">
        <div
          class="week-number__number"
          @click="emitAddEvent(week.week)"
          title="Luo uusi tapahtuma alkamaan tällä viikolla"
        >
          {{ week.week }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateString } from "@/helpers";
import { mapState } from "vuex";

// https://stackoverflow.com/questions/18478741/get-weeks-in-year
function getWeekNumber(d) {
  d = new Date(+d);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  var yearStart = new Date(d.getFullYear(), 0, 1);
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return [d.getFullYear(), weekNo];
}

function weeksInYear(year) {
  var d = new Date(year, 11, 31);
  var week = getWeekNumber(d)[1];
  return week == 1 ? 52 : week;
}

// https://stackoverflow.com/questions/16590500/javascript-calculate-date-from-week-number
function getDateOfISOWeek(w, y) {
  var simple = new Date(Date.UTC(y, 0, 1 + (w - 1) * 7));
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}

export default {
  data() {
    return {
      weekNumbers: [],
      currentYear: 2020
    };
  },
  computed: {
    ...mapState(["year"]),
  },
  watch: {
    year() {
      this.createWeekNumbers();
    }
  },
  created() {
    this.createWeekNumbers();
  },
  methods: {
    createWeekNumbers() {
      let weekNumbers = [];
      let yearWeeks = weeksInYear(this.year);
      for (var i = 1; i <= yearWeeks; i++) {
        let angle = ((i - 1) / yearWeeks) * 360 + 2;
        weekNumbers.push({
          week: i,
          style: {
            transform: "rotate(" + angle + "deg)",
          },
        });
      }
      this.weekNumbers = weekNumbers;
    },
    emitAddEvent(week) {
      var date = getDateOfISOWeek(week, this.year);
      this.$emit("add-event", getDateString(date));
    },
  },
};
</script>

<style lang="scss" scoped>
.week-number {
  display: inline-block;
  width: 20px;
  height: 45.5%;
  text-align: center;
  position: absolute;
  top: 4.5%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 1rem;
  line-height: 1;
  pointer-events: none;
  z-index: 100;

  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: inline-block;
    transform-origin: bottom center;
  }

  &__number {
    height: 1.7rem;
    width: 1.7rem;
    line-height: 1.7rem;
    border-radius: 50%;
    // line-height: 1.5rem;
    cursor: pointer;
    background: transparent;
    color: #333;
    pointer-events: all;

    &:hover {
      background: #aaa;
    }
  }
}
</style>
